import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { findSetting, realtimeSensorData } from '../_actions/user_action';
import setting from '../config/setting';

// 전역 변수 선언
let audioNH3 = null;
let audioH2S = null;

const RealtimeContainer = (props) => {
    const dispatch = useDispatch();
    // console.log('RealtimeContainer', props.userInfo);
    const userInfo = props.userInfo;
    // console.log('RealtimeContainer', props.graphDevice);

    const [settingInfo, setSettingInfo] = useState();
    const [realtimeInfo, setRealtimeInfo] = useState();
    const [isReady, setIsReady] = useState(false);

    const [realNH3, setRealNH3] = useState('');
    const [realH2S, setRealH2S] = useState('');
    const [realTEMP, setRealTEMP] = useState('');
    const [realHUM, setRealHUM] = useState('');

    const [realDevice, setRealDevice] = useState('None');
    const [realTime, setRealTime] = useState('None');
    const [realLatitude, setRealLatitude] = useState('None');
    const [realLongitude, setRealLongitude] = useState('None');

    const [realRssi, setRealRssi] = useState('None');
    const [realSnr, setRealSnr] = useState('None');

    useEffect(() => {
        const fetchSetting = async () => {
            setIsReady(false);
            const body = {
                id: userInfo.email,
                sensorMain: userInfo.sensorMain
            };

            try {
                const response = await dispatch(findSetting(body));
                if (response.payload.findSuccess) {
                    const setting = response.payload.settingInfo;
                    setSettingInfo(setting);
                    // console.log('fetchSetting - settingInfo: ', setting);
                    if (setting) {
                        displayRuntime(setting);
                    }
                }
            } catch (error) {
                console.error("Error fetching settings", error);
            }
        };

        fetchSetting();
    }, [userInfo.email, userInfo.sensorMain, dispatch]);

    useEffect(() => {
        if (!settingInfo || !settingInfo.userTerm) return;

        const timer = setInterval(() => {
            displayRuntime(settingInfo);
            // console.log("Home RealtimeContainer Reload - displayRuntime");
        }, settingInfo.userTerm * 1000);

        return () => clearInterval(timer);
    }, [settingInfo]);

    useEffect(() => {
        // console.log('Real-time NH3:', realNH3);
        // console.log('Real-time H2S:', realH2S);
        // console.log('Real-time TEMP:', realTEMP);
        // console.log('Real-time HUM:', realHUM);
    }, [realNH3, realH2S, realTEMP, realHUM]);

    const displayRuntime = (settingInfo) => {
        // console.log('settingInfo:', settingInfo);

        const today = new Date();
        const yesterday = new Date(today);
    
        const body = {
            device: [props.targetDevice], // ✅ 배열로 넘김
            startDate: yesterday,
            endDate: today
        };

        resetAlarms();
    
        dispatch(realtimeSensorData(body)).then(response => {
            const { findSuccess, realtimeSensorData } = response.payload || {};

            if (findSuccess && Array.isArray(realtimeSensorData) && realtimeSensorData.length > 0) {
                const dataInfo = realtimeSensorData[0];

                // console.log('✅ displayRuntime - dataInfo:', dataInfo);
                setRealtimeInfo(dataInfo);
                setRealtimeData(dataInfo); // ✅ 여기서 .length 접근 금지!
                setIsReady(true);

                operationSoundAlarm(dataInfo, settingInfo);
            } else {
                // console.warn('⚠️ No valid real-time sensor data received');
                setRealtimeInfo(null);
                setRealtimeData(null);
                setIsReady(false);
            }
        })
        .catch(error => {
            // console.error('❌ Error fetching real-time sensor data:', error);
            setRealtimeInfo(null);
            setRealtimeData(null);
            setIsReady(false);
        });
    };    

    const setRealtimeData = (realtimeDataInfo) => {
        // console.log('✅ displayRuntime - realtimeDataInfo:', realtimeDataInfo);
    
        const data = Array.isArray(realtimeDataInfo) ? realtimeDataInfo[0] : realtimeDataInfo;
    
        if (data) {
            // setRealNH3(toInteger(data.NH3));
            // setRealH2S(toInteger(data.H2S));
            // setRealTEMP(toInteger(data.Temperature));
            // setRealHUM(toInteger(data.Humidity));
            setRealNH3(data.NH3);
            setRealH2S(data.H2S);
            setRealTEMP(data.Temperature);
            setRealHUM(data.Humidity);
    
            let sensorId = data.DeviceId || '----';
            let maskedSensorId = '*'.repeat(sensorId.length - 4) + sensorId.slice(-4);
    
            const kstTime = data.KSTTime || '';
            setRealDevice(maskedSensorId);
            setRealTime(kstTime);
            setRealLatitude(data.Latitude);
            setRealLongitude(data.Longitude);

            setRealRssi(data.Rssi);
            setRealSnr(data.Snr);
    
            setIsReady(true); // 데이터가 정상적으로 처리된 후 상태 갱신
        } else {
            // console.warn('⚠️ No valid realtime sensor data available');
            setIsReady(false);
        }
    };

    useEffect(() => {
        // 기기 변경 시 모든 경고음을 초기화
        // console.log(`Device changed to: ${props.targetDevice}`);
        resetAlarms();
        setRealtimeInfo(null);
        setIsReady(false);
    }, [props.targetDevice]);    

    const resetAlarms = () => {
        if (audioNH3) {
            stopAlarm(audioNH3);
            audioNH3 = null;
        }
    
        if (audioH2S) {
            stopAlarm(audioH2S);
            audioH2S = null;
        }
    
        // console.log("All alarms and audio objects have been reset.");
    };
    
    const playAlarm = (type) => {
        try {
            const audio = new Audio(`/sounds/alarm_${type}.wav`);
            audio.loop = true;
            audio.play().catch((error) => {
                console.error("Audio play error:", error);
            });
            // console.log("Audio playing:", audio);
            return audio;
        } catch (error) {
            console.error("Failed to create audio object:", error);
            return null;
        }
    };    
    
    const stopAlarm = (audio) => {
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
            // console.log("Audio stopped:", audio);
        }
    };    
    
    const triggerAlarm = (gasType, currentValue, threshold, soundFlag) => {
        let audio;
    
        if (soundFlag && currentValue > threshold) {
            if (gasType === "NH3" && !audioNH3) {
                audioNH3 = playAlarm(gasType);
            } else if (gasType === "H2S" && !audioH2S) {
                audioH2S = playAlarm(gasType);
            }
        } else {
            if (gasType === "NH3" && audioNH3) {
                stopAlarm(audioNH3);
                audioNH3 = null;
            } else if (gasType === "H2S" && audioH2S) {
                stopAlarm(audioH2S);
                audioH2S = null;
            }
        }
    };    
    
    const operationSoundAlarm = (dataInfo, settingInfo) => {
        const data = Array.isArray(dataInfo) ? dataInfo[0] : dataInfo;
    
        // console.log('operationSoundAlarm - targetState:', props.targetState);
        // if (data) {
        if (data && props.targetState === "Online") {
            triggerAlarm("NH3", data.NH3, settingInfo.userLimitNH3, settingInfo.opLightLampNH3);
            triggerAlarm("H2S", data.H2S, settingInfo.userLimitH2S, settingInfo.opLightLampH2S);
        }
    };    

    return (
        <div>
            {/* NH3 */}
            <div className="graphList">
                <div className="graphTitle">
                    <p>NH3</p>
                    <p className="ppmText">
                        {(realNH3 != null && isReady)
                        ? parseFloat(realNH3).toFixed(2)
                        : '0.00'}{' '}
                        {settingInfo?.unitNH3 === 0 ? 'ppm' : 'ppb'}
                    </p>
                </div>
                <div className="home2Graph">
                    <meter
                        value={isReady ? realNH3 : 0}
                        min={setting.ammonia_min}
                        max={setting.ammonia_max}
                    />
                </div>
            </div>

            {/* H2S */}
            <div className="graphList">
                <div className="graphTitle">
                    <p>H2S</p>
                    <p className="ppmText">
                        {(realH2S != null && isReady)
                        ? parseFloat(realH2S).toFixed(2)
                        : '0.00'}{' '}
                        {settingInfo?.unitH2S === 0 ? 'ppm' : 'ppb'}
                    </p>
                </div>
                <div className="home2Graph">
                    <meter
                        value={isReady ? realH2S : 0}
                        min={setting.hydrogen_sulfide_min}
                        max={setting.hydrogen_sulfide_max}
                    />
                </div>
            </div>

            {/* Temperature */}
            <div className="graphList">
                <div className="graphTitle">
                    <p>Temperature</p>
                    <p className="ppmText">
                        {(realTEMP != null && isReady)
                        ? parseFloat(realTEMP).toFixed(2)
                        : '0.00'}{' '}
                        {settingInfo?.unitT === 0 ? '°C' : '°F'}
                    </p>
                </div>
                <div className="home2Graph">
                    <meter
                        value={isReady ? realTEMP : 0}
                        // min={setting.temperature_min}
                        max={setting.temperature_max}
                    />
                </div>
            </div>

            {/* Humidity */}
            <div className="graphList">
                <div className="graphTitle">
                    <p>Humidity</p>
                    <p className="ppmText">
                        {(realHUM != null && isReady)
                        ? parseFloat(realHUM).toFixed(3)
                        : '0.000'}{' '}
                        {setting.humidity_unit}
                    </p>
                </div>
                <div className="home2Graph">
                    <meter
                        value={isReady ? realHUM : 0}
                        min={setting.humidity_min}
                        max={setting.humidity_max}
                    />
                </div>
            </div>

            <br />

            {/* Sensor / Time / Lat / Lng */}
            <div className="graphList">
                <div className="graphTitle">
                    <p>Sensor</p>
                    <p className="ppmText">{isReady ? realDevice : '----'}</p>
                </div>
                <div className="graphTitle">
                    <p>Data Receive Time</p>
                    <p className="ppmText">{isReady ? realTime : '----'}</p>
                </div>
                <div className="graphTitle">
                    <p>Latitude</p>
                    <p className="ppmText">{isReady ? realLatitude : '----'}</p>
                </div>
                <div className="graphTitle">
                    <p>Longitude</p>
                    <p className="ppmText">{isReady ? realLongitude : '----'}</p>
                </div>
                <div className="graphTitle">
                    <p>RSSI</p>
                    <p className="ppmText">{isReady ? realRssi : '----'}</p>
                </div>
                <div className="graphTitle">
                    <p>SNR</p>
                    <p className="ppmText">{isReady ? realSnr : '----'}</p>
                </div>
            </div>
        </div>
    );
};

export default RealtimeContainer;
